import React, {FC} from 'react'
//@ts-ignore
import { LKModalTrigger } from 'shared/LKModal'
import AddClientForm from '../ClientForm'

import { ClientEditProps, ClientEditTriggerProps } from './clientEdit.types'

const ClientEdit: FC<ClientEditProps> = ({ onClientEdit, onClose, name, noVisibilityFilter }) => (
  <AddClientForm
    icon="client_edit"
    name={name}
    editting
    onClientAddEdit={onClientEdit}
    onClose={onClose}
    noVisibilityFilter={noVisibilityFilter}
  />
)

export const ClientEditTrigger: FC<ClientEditTriggerProps> = ({
  children,
  ID,
  hash,
  clientType,
  groupid,
  isPassPhraseRequired,
  name,
  disabled,
  fullWidth,
}) => (
  <LKModalTrigger
    params={{ ID, hash, clientType, groupid, isPassPhraseRequired }}
    name={name}
    alias="client_edit"
    permission="EDIT_CLIENT"
    disabled={disabled}
    style={{ width: fullWidth ? '100%' : 'auto' }}
  >
    {children}
  </LKModalTrigger>
)

ClientEdit.defaultProps = {
  ID: 0,
  type: 0,
}

export default ClientEdit
